import React from 'react';
import './Skeleton.css';

const Skeleton = ({ width = '100%', height = '1em', borderRadius = '8px', style = {}, className = '', ...props }) => (
  <span
    className={`skeleton-block ${className}`}
    style={{
      display: 'block',
      width,
      height,
      borderRadius,
      background: 'linear-gradient(90deg, #fbeee6 25%, #f5c6a5 50%, #fbeee6 75%)',
      backgroundSize: '200% 100%',
      ...style,
    }}
    aria-busy="true"
    aria-label="Cargando..."
    {...props}
  />
);

export default Skeleton;
